export enum QRType {
    Table = 1,
    Store,
    Company
  }